import { Authentication } from './authentication/authentication.service'
import { Brand } from './brand/brand.service'
import { Cache } from './cache/cache.service'
import { Certificate } from './certificate/certificate.service'
import { Company } from './company/company.service'
import { CompanyProduction } from './company-production/company-production.service'
import { CompanyProductionSteps } from './company-production-steps/company-production-steps.service'
import { Declaration } from './declaration/declaration.service'
import { FinishedItemProfile } from './finished-item-profile/finished-item-profile.service'
import { Invoices } from './invoices/invoices.service'
import { Items } from './items/items.service'
import { Network } from './network/network.service'
import { Order } from './order/order.service'
import { OrderProduction } from './order-production/order-production.service'
import { Products } from './products/products.service'
import { Providers } from './providers/providers.service'
import { Reports } from './reports/reports.service'
import { Settings } from './settings/settings.service'
import { Traceability } from './traceability/traceability.service'
import { User } from './user/user.service'
import { Request } from './utils/http'

export interface FairFashionOptions {
  baseURL: string
  headers?: Record<string, unknown>
}

export class FairFashion {
  private baseURL: string
  private headers?: Record<string, unknown>
  public authentication: Authentication
  public company: Company
  public cache: Cache
  public invoices: Invoices
  public traceability: Traceability
  public brand: Brand
  public user: User
  public providers: Providers
  public order: Order
  public settings: Settings
  public finishedItemProfile: FinishedItemProfile
  public companyProduction: CompanyProduction
  public orderProduction: OrderProduction
  public companyProductionSteps: CompanyProductionSteps
  public network: Network
  public reports: Reports
  public items: Items
  public products: Products
  public declaration: Declaration
  public certificate: Certificate

  constructor(options: FairFashionOptions) {
    this.baseURL = options.baseURL
    this.headers = options.headers

    const fairfashionProvider = new Request({
      baseURL: this.baseURL,
      headers: this.headers,
    })

    this.brand = new Brand(fairfashionProvider)
    this.authentication = new Authentication(fairfashionProvider)
    this.company = new Company(fairfashionProvider)
    this.cache = new Cache(fairfashionProvider)
    this.invoices = new Invoices(fairfashionProvider)
    this.traceability = new Traceability(fairfashionProvider)
    this.user = new User(fairfashionProvider)
    this.providers = new Providers(fairfashionProvider)
    this.order = new Order(fairfashionProvider)
    this.settings = new Settings(fairfashionProvider)
    this.finishedItemProfile = new FinishedItemProfile(fairfashionProvider)
    this.companyProduction = new CompanyProduction(fairfashionProvider)
    this.orderProduction = new OrderProduction(fairfashionProvider)
    this.companyProductionSteps = new CompanyProductionSteps(
      fairfashionProvider,
    )
    this.network = new Network(fairfashionProvider)
    this.reports = new Reports(fairfashionProvider)
    this.items = new Items(fairfashionProvider)
    this.products = new Products(fairfashionProvider)
    this.declaration = new Declaration(fairfashionProvider)
    this.certificate = new Certificate(fairfashionProvider)
  }
}
